export const defaultSums = [1, 2, 5, 10, 20, 50, 100, 200, 500]
export const tipsSums = [1, 2, 3, 4, 5, 6, 10, 15, 20]